import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import gql from 'graphql-tag';
import max from 'date-fns/max';
import addDays from 'date-fns/addDays';

import toISODateString from '../../../shared/utils/toISODateString';
import ProviderBody from './ProviderBody';

export const nextOpeningQuery = gql`
  query ProviderSchedulingNextOpening($providerId: ID!, $reasonForVisitId: ID!, $after: String!) {
    nextOpening(providerId: $providerId, reasonForVisitId: $reasonForVisitId, after: $after) {
      id
      time
      provider {
        id
      }
    }
  }
`;

export const openingsQuery = gql`
  query ProviderSchedulingOpenings(
    $providerId: ID!
    $reasonForVisitId: ID!
    $after: String!
    $before: String!
  ) {
    openings(
      providerId: $providerId
      reasonForVisitId: $reasonForVisitId
      after: $after
      before: $before
    ) {
      pageInfo {
        nextAvailableDate
      }
      nodes {
        id
        time
        provider {
          id
        }
      }
    }
  }
`;

const withNextOpeningData = graphql(nextOpeningQuery, {
  name: 'nextOpeningData',
  options(props) {
    const { provider, schedule } = props;
    const {
      values: { reasonForVisit, minDate },
    } = schedule;
    return {
      variables: {
        providerId: provider.id,
        reasonForVisitId: reasonForVisit.id,
        after: toISODateString(minDate),
      },
    };
  },
});

const withOpeningsData = graphql(openingsQuery, {
  name: 'openingsData',
  options(props) {
    const { provider, schedule } = props;
    const {
      values: { reasonForVisit, selectedDate, minDate },
    } = schedule;
    const after = max([selectedDate, minDate]);

    return {
      variables: {
        providerId: provider.id,
        reasonForVisitId: reasonForVisit.id,
        after: toISODateString(after),
        // Querying 8 days of data due to openings being clipped for (HST, UTC-10) timezone because of the big time difference.
        before: toISODateString(addDays(after, 8)),
      },
    };
  },
});

export default compose(withNextOpeningData, withOpeningsData)(ProviderBody);
